import { render, staticRenderFns } from "./zonglanRight.vue?vue&type=template&id=d130288c&scoped=true&"
import script from "./zonglanRight.vue?vue&type=script&lang=js&"
export * from "./zonglanRight.vue?vue&type=script&lang=js&"
import style0 from "./zonglanRight.vue?vue&type=style&index=0&id=d130288c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d130288c",
  null
  
)

export default component.exports